import { defineMessages } from 'react-intl';

export const messages: {
	workItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	epicLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bugLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	storyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	milestoneLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	approvalLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	problemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	questionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ticketLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestedItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	catalogItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	for: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	isAssigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	created: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	workItemLabel: {
		id: 'search-graph-work-item.label',
		defaultMessage: 'Work item',
		description: 'Work item label',
	},
	taskLabel: {
		id: 'search-graph-work-item.task.label',
		defaultMessage: 'Task',
		description: 'Task label',
	},
	epicLabel: {
		id: 'search-graph-work-item.epic.label',
		defaultMessage: 'Epic',
		description: 'Epic label',
	},
	bugLabel: {
		id: 'search-graph-work-item.bug.label',
		defaultMessage: 'Bug',
		description: 'Bug label',
	},
	storyLabel: {
		id: 'search-graph-work-item.story.label',
		defaultMessage: 'Story',
		description: 'Story label',
	},
	milestoneLabel: {
		id: 'search-graph-work-item.milestone.label',
		defaultMessage: 'Milestone',
		description: 'Milestone label',
	},
	sectionLabel: {
		id: 'search-graph-work-item.section',
		defaultMessage: 'Section',
		description: 'Section label',
	},
	approvalLabel: {
		id: 'search-graph-work-item.approval',
		defaultMessage: 'Approval',
		description: 'Approval label',
	},
	problemLabel: {
		id: 'search-graph-work-item.problem',
		defaultMessage: 'Problem',
		description: 'Problem label',
	},
	incidentLabel: {
		id: 'search-graph-work-item.incident',
		defaultMessage: 'Incident',
		description: 'Incident label',
	},
	questionLabel: {
		id: 'search-graph-work-item.question',
		defaultMessage: 'Question',
		description: 'Question label',
	},
	issueLabel: {
		id: 'search-graph-work-item.issue',
		defaultMessage: 'Issue',
		description: 'Issue label',
	},
	ticketLabel: {
		id: 'search-graph-work-item.ticket',
		defaultMessage: 'Ticket',
		description: 'Ticket label',
	},
	requestedItemLabel: {
		id: 'search-graph-work-item.requested_item',
		defaultMessage: 'Requested item',
		description: 'Requested item label',
	},
	catalogItemLabel: {
		id: 'search-graph-work-item.catalog_item',
		defaultMessage: 'Catalog item',
		description: 'Catalog item label',
	},
	for: {
		id: 'work-item-status.for',
		defaultMessage: '{statusLozenge} for {dateLozenge}',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'work-item-assignee.assigned',
		defaultMessage:
			'{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
		description: 'Text that goes after assignee name',
	},
	created: {
		id: 'work-item-creator.created',
		defaultMessage:
			'{created, select, internal {{firstName} created} other {External person created}}',
		description: 'Text that goes after creator name',
	},
});
